<template>
  <section class="practice">
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" id="content" class="content successReport success-reports-info col-md-9 col-sm-12">
        <!-- <div v-if="this.userfocusData && this.userfocusData > 0" class="material-box bg-white"> -->
        <div
          v-if="(loginUser.Status !== 'PDC' && this.userfocusData && this.userfocusData > 0) || loginUser.Status === 'PDC' || loginUser.Status === 'PCA'"
          class="material-box bg-white">

          <div class="row content-row">
            <div class="col-md-12 top-title">
              <h3>Success Rate Reports</h3>
            </div>
            <!-- begin section-container -->
            <div class="col-md-12">
              <div class="section-container section-with-top-border patient_report">
                <div class="inner_patient_report">
                  <div class="row" style="align-items: flex-end">
                    <div class="col-lg-3 col-md-6 col-sm-6 form-group">
                      <label>Select User </label>
                      <b-form-select id="Prefix" v-model="form.UserID" :options="users" value-field="id"
                        text-field="name">
                      </b-form-select>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 form-group">
                      <label>Select Report</label>
                      <b-form-select id="Prefix" v-model="form.FocusCode" :options="allFocus" value-field="FocusCode"
                        text-field="FocusName">
                      </b-form-select>
                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-6 form-group">
                      <label>Select Year </label>
                      <b-form-select id="Prefix" v-model="form.year" :options="years">
                      </b-form-select>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6 flex-btns form-group pull-left">
                      <button @click="resetReport" class="btn btn-default btn-white mr-1 m-t-20">
                        Reset
                      </button>
                      <button value="Submit" @click="getReportData" name="DetailReport"
                        class="btn btn-primary m-t-20 btn-blue">
                        Submit
                      </button>
                      <button @click="printReport" class="btn btn-default btn-white mt-1 ml-1 pull-right m-t-20">
                        Print Report
                      </button>
                    </div>
                  </div>

                  <div id="print-box">
                    <!-- begin panel -->
                    <div class="row">
                      <div class="col-lg-12 title">
                        <h4 class="color-grey">{{ loginUser.PracticeName }}</h4>
                        <h2 style="font-family: Calibri">
                          Success Rate Report - {{ table.title }} -
                          {{ form.year }}
                        </h2>
                      </div>
                      <div class="col-lg-12">
                        <div class="report-defined">
                          <h3>Defined:</h3>
                          <p>
                            <template v-if="focusData.Definition1">
                              • &nbsp;<span v-html="focusData.Definition1"></span>
                              <br />
                            </template>
                            <template v-if="focusData.Definition2">
                              • &nbsp;<span v-html="focusData.Definition2"></span>
                              <br />
                            </template>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="report-action">
                          <h3>Action Steps:</h3>
                          <p>
                            <template v-for="i in Object.keys(focusData).filter(
                              (key) =>
                                key.startsWith('ActionStep') &&
                                focusData[key] !== null
                            )">
                              <p :key="i" v-if="focusData[i]">
                                &bull; &nbsp;{{ focusData[i] }}
                              </p>
                            </template>
                          </p>
                        </div>
                        <div style="padding-left: 0px; margin-top: 0px" class="col-lg-12">
                          <h4 style="font-size: 21px; margin-top: 0px" class="heading_h4">
                            Success Rate Target: &nbsp;
                            <span> {{ focusData.Target }}% </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div class="pagination-default clearfix m-b-0">
                      <div class="table-responsive">
                        <table id="data-table" class="table table-bordered table-hover patient-report-table">
                          <thead>
                            <tr class="default">
                              <th data-sorting="disabled"></th>
                              <th style="text-align: center">
                                <b>{{ table.c1 }}</b>
                              </th>
                              <th style="text-align: center">
                                <b>{{ table.c2 }}</b>
                              </th>
                              <th style="text-align: center">
                                <b>{{ table.c3 }}</b>
                              </th>
                              <th style="text-align: center">
                                <b>Monthly Average</b>
                              </th>
                              <th style="text-align: center">
                                <b>Success Rate</b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="odd gradeX" v-for="(report, i) in reports" :key="i">
                              <td style="font-size: 16px">
                                {{ report.title }}
                              </td>
                              <td style="font-size: 16px">
                                {{ formatNumber(report.m_goal) }}
                              </td>
                              <td style="font-size: 16px">
                                <template v-if="compareDate(i, cyear)">
                                  {{ formatNumber(report.m_actual) }}
                                </template>
                                <template v-else>
                                  0
                                </template>
                                <!-- {{ formatNumber(report.m_actual) }} -->
                              </td>
                              <td style="font-size: 16px">
                                {{ report.reach1 >= 0 ? `+${formatNumber(Math.round(report.reach1))}` :
                                  formatNumber(Math.round(report.reach1)) }}
                              </td>
                              <td style="font-size: 16px">
                                <template v-if="compareDate(i, cyear)">
                                  {{ report.m_avg }}%
                                </template>
                                <template v-else>
                                  0%
                                </template>
                              </td>
                              <td style="font-size: 16px">
                                <template v-if="compareDate(i, cyear)">
                                  {{ report.y_avg }}%
                                </template>
                                <template v-else>
                                  0%
                                </template>
                                <!-- {{ report.y_avg }}% -->
                              </td>
                            </tr>

                            <tr class="even gradeC">
                              <td style="font-size: 16px" class="subtotal">
                                <b>Total:</b>
                              </td>
                              <td style="font-size: 16px; text-align: center">
                                {{ reports[11] ? reports[11].total_goal : 0 }}
                              </td>
                              <td style="font-size: 16px; text-align: center">
                                {{
                                  reports[11] && reports[11].m_actual != 0
                                    ? reports[11].total_actuals
                                    : (reports[getMonth()] ? reports[getMonth()].total_actuals - reports[getMonth()].m_actual : 0)
                                }}
                              </td>

                              <td>{{ totalRowDifference }}</td>

                              <td></td>
                              <td style="text-align: center; font-size: 16px" class="total">
                                <b>{{ totalAvgs }}% </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!-- end panel -->
                    <div>
                      <div class="form-group">
                        <label style="padding-left: 0"
                          class="control-label col-lg-2 col-m-3 col-sm-4 co-xs-12">Benefits/Reward</label>
                        <div class="col-lg-10 col-md-9 col-sm-8 col-xs-12 border-none">
                          <p>{{ reports[getMonth()] ? (reports[getMonth()]["benefits"] || 0) : 0 }}</p>
                        </div>
                      </div>
                      <span class="pull-left"><b>{{ date }}</b></span>
                      <span class="pull-right" style="margin-left: -5%;"><b
                          style="width:190px; display:block; letter-spacing: 0.6px;">{{
                            loginUser.PracticeName }}</b></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end section-container -->

            <!-- end #content -->
          </div>
        </div>
        <div v-else class="material-box bg-white">
          <div class="row content-row">
            <div class="col-md-12 top-title">
              <h3>Success Rate Reports</h3>
            </div>
            <p style=" margin-left: 2%;">Sorry You have no assigned focus</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import practiceSidebar from "./../Practice/components/Sidebar.vue";
import userAPI from "../userApi";
import moment from "moment";
import jsPDF from "jspdf";
import 'jspdf-autotable';

Vue.use(jsPDF);
export default {
  name: "practice_dashboard",
  components: {
    practiceSidebar,
  },
  data() {
    return {
      cyear: new Date().getFullYear(),
      isLoading: false,
      date: moment().format("dddd, MMMM D, YYYY"),
      loginUser: {},
      table: {},
      users: [
        {
          id: 0,
          name: "Practice",
        },
      ],
      focusData: {},
      userfocusData: 1,
      form: {
        UserID: 0,
        year: moment().format("Y"),
        FocusCode: "",
      },
      allFocus: {},
      years: [],
      reports: {},
      totalMActual: '',
    };
  },
  methods: {
    formatNumber(value) {
      return value.toLocaleString();
    },
    resetReport() {
      this.form = {
        UserID: 0,
        year: moment().format("Y"),
        FocusCode: this.focusData.FocusCode,
      };
      this.getReportData();
    },
    printReport() {
      let print = document.getElementById("print-box");

      const doc = new jsPDF();
      doc.html(print, {
        callback: function (doc) {
          doc.save("Report.pdf");
        },
        margin: [10, 10, 10, 10],
        autoPaging: "text",
        x: 0,
        y: 0,
        width: 190,
        windowWidth: 875,
      });
    },
    monthNumberAvg() {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let currentMonth = currentDate.getMonth();
      let monthNumberAvg = "";

      if (this.form.year < currentYear) {
        monthNumberAvg = 12;
      } else if (this.form.year == currentYear) {
        monthNumberAvg = currentMonth - 1;

        if (monthNumberAvg === 0) {
          monthNumberAvg = currentMonth;
        }
      } else {
        monthNumberAvg = 1;
      }

      return monthNumberAvg;
    },
    getMonth() {
      let currentDate = new Date();
      return currentDate.getMonth();
    },
    compareDate(i, year) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let currentMonth = currentDate.getMonth();
      if (currentYear > year) {
        return true;
      } else if (currentYear == year) {
        return currentMonth > i;
      } else {
        return false;
      }
    },
    getReportData() {
      if (this.form.FocusCode == "NP") {
        this.table.title = "New Patient";
        this.table.c1 = "Goal";
        this.table.c2 = "Actual";
        this.table.c3 = "Difference";
      } else if (this.form.FocusCode == "ROF") {
        this.table.title = "Report of Findings";
        this.table.c1 = "Arrived";
        this.table.c2 = "Started";
        this.table.c3 = "Difference";
      } else if (this.form.FocusCode == "PV") {
        this.table.title = "Patient Visits";
        this.table.c1 = "Goal";
        this.table.c2 = "Actual";
        this.table.c3 = "Difference";
      } else if (this.form.FocusCode == "CPR") {
        this.table.title = "Care Plan Renewals";
        this.table.c1 = "Arrived";
        this.table.c2 = "Started";
        this.table.c3 = "Difference";
      } else if (this.form.FocusCode == "REV") {
        this.table.title = "Revenue";
        this.table.c1 = "Goal";
        this.table.c2 = "Actual";
        this.table.c3 = "Difference";
      } else {
        this.$router.push({ name: "success_report" });
      }

      userAPI.getReportFocusData(
        this.form,
        (res) => {
          this.focusData = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
      userAPI.getUserFocusesById(
        { userid: this.loginUser.userID },
        (res) => {
          this.userfocusData = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
      userAPI.getReportData(
        { practiceID: this.loginUser.PracticeID, ...this.form },
        (res) => {
          this.reports = res.data;
          this.cyear = this.form.year
          this.totalMActual = res.data.reduce((total, report) => total + report.m_actual, 0);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getUsersByPractice() {
      this.isLoading = true;
      userAPI.getUsersByPractice(
        { practiceID: this.loginUser.PracticeID },
        (res) => {
          res.data.data.forEach((element) => {
            this.users.push({
              id: element.UserID,
              name: `${element.FirstName} ${element.LastName}`,
            });
          });
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
    getAllFoucs() {
      userAPI.getAllFoucs(
        (res) => {
          this.form.FocusCode = res.data.data[0].FocusCode;
          this.allFocus = res.data.data;
          this.getReportData();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setYears() {
      let currentYear = parseInt(moment().format("Y")) + 1;
      for (let index = 2018; index <= currentYear; index++) {
        this.years.push(index);
      }
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;
    this.getUsersByPractice();
    this.getAllFoucs();
    this.setYears();
  },
  computed: {
    totalRowDifference() {
      const r11 = this.reports[11];
      const rMonth = this.reports[this.getMonth()];
      const totalGoal = r11 ? r11.total_goal : 0;
      // Use same logic as the Actual cell in the Total row
      const totalActuals = (r11 && r11.m_actual != 0)
        ? (r11.total_actuals || 0)
        : (rMonth ? (rMonth.total_actuals - rMonth.m_actual) : 0);
      const diff = totalActuals - totalGoal;
      return diff >= 0 ? '+' + diff.toLocaleString() : diff.toLocaleString();
    },
    totalAvgs() {
      const rAvg = this.reports[this.monthNumberAvg()];
      const r11 = this.reports[11];
      if (rAvg && rAvg["total_avgs"] != null) {
        return rAvg["total_avgs"];
      }
      return r11 ? r11.total_avgs : 0;
    },
  },
};
</script>

<style>
.flex-btns {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

@media (max-width: 550px) {

  .report-defined h3,
  .report-action h3 {
    font-size: 18px;
  }

  #print-box .title br:nth-child(1) {
    display: none;
  }

  #print-box .title h2 {
    font-size: 24px;
  }
}
</style>